import React from 'react';

// El texto del mensaje viene del back como HTML: lo que escribió el usuario
// (sin escapar) más, para archivos, "<br/><a href='…'>nombre</a>". Aquí se
// convierte a elementos React conservando SOLO texto, <br> y <a href> con
// http(s); cualquier otra etiqueta o atributo se descarta. Así un mensaje con
// <script> o <img onerror> se muestra como texto y no se ejecuta.

const URL_SEGURA = /^https?:\/\//i;

function nodoAReact(nodo, clave) {
  if (nodo.nodeType === 3) {
    return nodo.textContent;
  }
  if (nodo.nodeType !== 1) {
    return null;
  }
  const etiqueta = nodo.tagName.toLowerCase();
  const hijos = Array.from(nodo.childNodes).map((h, i) => nodoAReact(h, clave + '-' + i));
  if (etiqueta === 'br') {
    return <br key={clave} />;
  }
  if (etiqueta === 'a') {
    const href = (nodo.getAttribute('href') || '').trim();
    if (URL_SEGURA.test(href)) {
      return (
        <a key={clave} className="chat-adjunto" href={href} target="_blank" rel="noopener noreferrer">
          <span className="chat-adjunto-icono" aria-hidden="true"></span>
          {hijos}
        </a>
      );
    }
    return <React.Fragment key={clave}>{hijos}</React.Fragment>;
  }
  // Cualquier otra etiqueta: se conserva el texto interior, no la etiqueta.
  return <React.Fragment key={clave}>{hijos}</React.Fragment>;
}

export function sanitizarMensaje(html) {
  if (html === null || html === undefined) {
    return null;
  }
  const texto = String(html);
  if (typeof DOMParser === 'undefined') {
    return texto;
  }
  const doc = new DOMParser().parseFromString('<div>' + texto + '</div>', 'text/html');
  const raiz = doc.body.firstChild;
  if (!raiz) {
    return texto;
  }
  return Array.from(raiz.childNodes).map((n, i) => nodoAReact(n, 'n' + i));
}

/** True si el mensaje trae un enlace de adjunto (lo genera el back). */
export function tieneAdjunto(html) {
  return /<a\s/i.test(String(html || ''));
}
